/**
 * useControlStyles - SINGLE source of truth for the topbar "control" look
 * (language toggle, role badge, settings, logout). Both TopBar and the
 * shared LanguageSwitcher import this so the pill style is defined ONCE.
 */
import { makeStyles } from '@material-ui/core/styles';

export const useControlStyles = makeStyles(theme => ({
  // Base control pill: fixed 34px height, centred content, consistent padding.
  control: {
    height: 34,
    minHeight: 34,
    minWidth: 34,
    padding: theme.spacing(0, 1.25),
    boxSizing: 'border-box',
    borderRadius: theme.shape.borderRadius * 1.5,
    border: `1px solid ${theme.palette.divider}`,
    background: 'transparent',
    color: theme.palette.text.primary,
    fontFamily: 'inherit',
    fontSize: '0.78rem',
    fontWeight: 600,
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.75),
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    transition: 'background 120ms ease, border-color 120ms ease',
    '&:hover': {
      background: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  logoutBtn: {
    backgroundColor: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
      borderColor: theme.palette.error.dark,
    },
  },
  icon: { fontSize: '1.1rem', color: 'inherit' },
  iconAccent: { fontSize: '1rem', color: theme.palette.secondary.main },
  // Display-only variant (role badge): filled, no hover affordance.
  readonly: {
    background: theme.palette.action.selected,
    cursor: 'default',
    '&:hover': {
      background: theme.palette.action.selected,
      borderColor: theme.palette.divider,
    },
  },
}));
